/**
 * Created by sswaminathan on 11/14/22
 * File: regionFilter
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

import { groupBy, keyBy } from 'lodash'
import { APP_ID_LOGGING_SERVICE, APP_ID_PAN_CHINA } from '../../../../common/constants/GlobalConstants'
import { isNonemptyArray } from '../../../../hub/utils/common'
import type { IDropDownData } from '../DropDown/DropDown'
import type { AppManifests } from '@sparky/framework'

type RegionFilter = {
  appIdList: string[],
  apps: AppManifests,
  supportAccountId: string,
  allowFederal?: boolean,
}
const regionFilter: (props: RegionFilter) => IDropDownData[] = (props) => {
  const { appIdList, apps, supportAccountId = '', allowFederal = false } = props
  //const enableAppLevelRegion = getVarValue(FF_ENABLE_APP_LEVEL_REGION, null)
  const enableAppLevelRegion = true
  const regionDropDown: Array<IDropDownData> = []
  const regionMap = keyBy(apps, 'app_id')
  // this is for reading region value to display name
  const platformRegionMap = regionMap['platform']?.regions
  const appRegionMaps = getAppProviderRegions(appIdList, regionMap, supportAccountId, allowFederal)
  const appRegionKeys = Object.keys(appRegionMaps)
  // start from the platform Region manifest
  platformRegionMap?.forEach((each: any) => {
    let includeRegion = true
    appRegionKeys.forEach((element) => {
      // handle global region
      if (!appRegionMaps[element].includes(each.name) && !appRegionMaps[element].includes('global')) {
        includeRegion = false
      }
    })
    if (includeRegion) {
      const regionObject = {
        value: each.display,
        description: each.name,
        id: each.name
      }
      regionDropDown.push(regionObject)
    }
  })
  enableAppLevelRegion && updateAppBasedRegion(regionDropDown, appIdList, regionMap, supportAccountId)
  return regionDropDown
}
const getAppProviderRegions = ((appIdList: Array<string>, regionMap: any, supportAccountId: string, allowFederal: boolean) => {
  const result: any = {}
  appIdList?.forEach((each: string) => {
    const appRegionList = regionMap[each]?.regions ?? false
    if (!appRegionList) {
      return
    }
    // // To check if the China SKu is available
    // const isChinaRegionAvailable = appRegionList.some((region: any) => region.name === 'cn')
    // if (isChinaRegionAvailable && !appIdList.includes(APP_ID_PAN_CHINA)) {
    //   appRegionList = appRegionList.filter((elem: any) => elem.name !== 'cn')
    // }
    const regions: Array<string> = []
    appRegionList.forEach((element: any) => {
      const filteredAccount: Array<string> = []
      // To apply restricted accounts on the platform region level
      if (element?.platform_region_extra) {
        const keys = Object.keys(element?.platform_region_extra)
        keys.forEach((regionKey) => {
          const restricted_region = element?.platform_region_extra[regionKey].restricted_accounts
          if (restricted_region && !restricted_region.includes(+supportAccountId)) {
            filteredAccount.push(regionKey)
          }
        })
      }
      if (isNonemptyArray(element.restricted_accounts) && !element.restricted_accounts.includes(+supportAccountId)) {
        return
      }

      if (element.supported_types?.federal && !allowFederal) {
        return
      }
      if (element.platform_regions) {
        const filteredRegions = element.platform_regions.filter((each: string) => !filteredAccount.includes(each))
        regions.push(...filteredRegions)
      }
      else if (element.logging_service_region) {
        regions.push(element.logging_service_region)
      }
      else if (element.name === 'global') {
        regions.push('global')
      }
    })
    result[each] = regions
  }
  )
  return result
})

/**
 *  This method will add the additional regions based on the app_ids
 * @type {updateAppBasedRegion}
 */
const updateAppBasedRegion = ((
  regionDropDown: Array<IDropDownData>,
  appIdList: Array<string>,
  regionMap: any,
  supportAccountId: string
) => {
  if (isNonemptyArray(regionDropDown)) {
    /**
     *  Iterate through each region in the dropdrown
     * For each app in the license check if there is any multiple region associated with it. IF there is any
     * restricted account present in the region, only for that restricted CSP add the additional region mapping
     */
    regionDropDown.forEach((region) => {
      appIdList.forEach((each: string) => {
        const appRegionList = regionMap[each]?.regions ?? false
        if (appRegionList && each !== APP_ID_LOGGING_SERVICE) {
          const multipleRegionList: Array<IDropDownData> = []
          appRegionList.forEach((appRegion: any) => {
            if (appRegion.platform_regions?.includes(region.id)) {
              if (appRegion.restricted_accounts && appRegion.restricted_accounts.includes(+supportAccountId)) {
                multipleRegionList.push({
                  value: appRegion.display,
                  description: appRegion.name,
                  id: appRegion.name
                })
              }
              else if (!appRegion.restricted_accounts) {
                multipleRegionList.push({
                  value: appRegion.display,
                  description: appRegion.name,
                  id: appRegion.name
                })
              }
            }
          })
          const groupByRegionName = groupBy(multipleRegionList, 'id')
          const regionKey = Object.keys(groupByRegionName)
          if (isNonemptyArray(multipleRegionList) && regionKey.length > 1) {
            multipleRegionList.unshift({
              value: `Select A ${regionMap[each].display_name} Region`,
              description: `Select A ${regionMap[each].display_name} Region`,
              id: ''
            })
            if (!region.additional_region_mapping) {
              region.additional_region_mapping = {
                [each]: multipleRegionList
              }
            }
            else {
              region.additional_region_mapping[each] = multipleRegionList
            }
          }
        }
      })
    })
  }
})

export default regionFilter
